/* Patrons default is 50px for a text input, and ideall we want everything
 * to be the same height. Legacy `ApplicantSettings` had this set to 38px */
export const INPUT_HEIGHT = 38;

/* When form validation errors render, it changes the position of the edit/save button.
 * This is a constant to hold it in place along the input alignment */
export const INPUT_LABEL_HEIGHT = 20;
